import { CurrencyCode } from './currency-code';

export class Money {
    public cents: number;
    public currencyCode: CurrencyCode;
    constructor(obj?: { cents?: number; currencyCode?: CurrencyCode }) {
        if (obj != null) {
            this.cents = typeof obj.cents === 'undefined' ? this.cents : obj.cents;
            this.currencyCode =
                typeof obj.currencyCode === 'undefined' ? this.currencyCode : obj.currencyCode;
        }
    }
}
